(() => {
  const normalize = value => String(value || '').trim().toLowerCase()
    .replace(/\bmac(?:aroni)?\s*(?:and|&|n['’]?)\s*cheese\b/g, 'mac n cheese')
    .replace(/\bbarbeque\b/g, 'barbecue').replace(/\s+/g, ' ');
  window.PurefectSearch = { normalize };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, location.href);
    if (!/\/search\/?$/.test(action.pathname)) return;
    const input = form.querySelector('input[name="q"]');
    if (input) input.value = normalize(input.value);
  }, true);
})();
